import React from "react";
import {
  faLaptopCode, // For Websites & Web Apps
  faMobileAlt, // For Mobile Applications
  faCogs, // For Custom Software
  faServer, // For DevOps Consulting
  faBullhorn, // For Digital Marketing
  faSearch, // For SEO
} from "@fortawesome/free-solid-svg-icons";
import Service from "../components/Service";
import useScrollAnimation from "../components/useScrollAnimation";

// Define type for each service item
type ServiceItem = {
  title: string;
  description: string;
  icon: any; // FontAwesome icon type, adjust as per actual type if necessary
  backgroundImage: string;
  orientation: "left" | "right"; // Enforce left or right as allowed values
};

const Servicepage: React.FC = () => {
  useScrollAnimation();
  const services: ServiceItem[] = [
    {
      title: "Websites & Web Apps",
      description:
        "We specialize in creating responsive websites and dynamic web applications tailored to your business needs. Our solutions combine cutting-edge technology and intuitive design for a seamless user experience.",
      icon: faLaptopCode,
      backgroundImage: "/service1.jpg",
      orientation: "left", // Image on the left
    },
    {
      title: "Mobile Applications",
      description:
        "We specialize in developing user-friendly and feature-rich mobile applications tailored to your business needs. Our solutions ensure seamless performance, scalability, and an exceptional user experience across platforms.",
      icon: faMobileAlt,
      backgroundImage: "/service2.jpg",
      orientation: "right", // Image on the right
    },
    {
      title: "Custom Software",
      description:
        "We design and develop custom software tailored to your unique business needs, ensuring seamless functionality and scalability. Our solutions enhance efficiency and drive innovation, delivering measurable results for your organization.",
      icon: faCogs,
      backgroundImage: "/service3.jpg",
      orientation: "left",
    },
    {
      title: "DevOps Consulting and Implementation",
      description:
        "Streamline your software development lifecycle with expert DevOps solutions, enabling faster deployment, enhanced collaboration, and robust infrastructure management.",
      icon: faServer,
      backgroundImage: "/service6.jpg",
      orientation: "right",
    },
    {
      title: "Digital Marketing",
      description:
        "Boost your online presence with tailored digital marketing strategies, including social media campaigns, content creation, and targeted advertising.",
      icon: faBullhorn,
      backgroundImage: "/service5.jpg",
      orientation: "left",
    },
    {
      title: "Search Engine Optimization (SEO)",
      description:
        "Improve your website’s visibility on search engines through advanced SEO techniques, driving organic traffic and enhancing your brand’s reach.",
      icon: faSearch,
      backgroundImage: "/service4.jpg",
      orientation: "right",
    },
  ];

  return (
    <>
      <div className="relative w-full h-[50vh] md:h-[80vh] animate-fadeIn">
        {/* Background Image */}
        <img
          src="service-bg.jpg"
          className="object-cover w-full h-full object-center opacity-25"
          alt="Background"
          loading="lazy"
        />

        {/* Centered Text */}
        <div className="absolute inset-0 flex flex-col justify-center items-center p-4  bg-opacity-40">
          <h1 className="text-white font-bold text-4xl sm:text-5xl md:text-6xl  p-4 rounded-md animate-fadeIn">
            Services
          </h1>
          <div className="p-4 md:mt-[7vh] flex flex-col justify-center items-center">
            <p className="text-gray-300  md:w-[90vh] text-md sm:text-lg md:text-xl shadow-lg text-center animate-fadeIn">
              At Pals Infotech, we offer a wide range of services aimed at
              enhancing your business's digital presence. From
              <span className="text-[#ae0c00]">
                {" "}
                custom software development
              </span>{" "}
              to
              <span className="text-[#ae0c00]"> DevOps consulting</span> and
              <span className="text-[#ae0c00]"> mobile applications</span>, we
              ensure that each solution is tailored to your unique needs. Our
              goal is to help you stay ahead of the competition by providing
              <span className="text-[#ae0c00]">
                {" "}
                cutting-edge technology
              </span>{" "}
              and
              <span className="text-[#ae0c00]">
                {" "}
                exceptional customer service
              </span>
              .
            </p>
          </div>
        </div>
      </div>
      <div className="text-white py-12 w-full bg-[#F0F0F0]">
        {/* Service List with Alternating Layout */}
        <div className="flex flex-col animate-fadeIn">
          {services.map((service, index) => (
            <Service
              key={index}
              title={service.title}
              description={service.description}
              icon={service.icon}
              backgroundImage={service.backgroundImage}
              orientation={service.orientation}
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default Servicepage;
